import { readUserPanelConfigsTable } from '.';
import { getOwnerID } from '../../utils/DryCookies';
import logger from '../../logger';
import { HasUserPanelConfigsLocalDatabaseContentType } from '../../types/userPanelConfigs';

export const checkUserPanelConfigsLocalDatabaseContent = async () => {
  console.log('hasUserPanelConfigsLocalDatabaseContent');
  const ownerId = getOwnerID() as string;
  let hasUserPanelConfigsLocalDatabaseContent = false as HasUserPanelConfigsLocalDatabaseContentType;
  if (!ownerId) {
    logger.info('Local database content NOT FOUND');
    return {
      hasUserPanelConfigsLocalDatabaseContent: hasUserPanelConfigsLocalDatabaseContent,
    };
  }

  try {
    const userPanelConfigsLocalDatabaseContent = await readUserPanelConfigsTable();
    logger.debug(userPanelConfigsLocalDatabaseContent, 'Local database content FOUND');
    const hasUserPanelConfigsLocalDatabaseContent = Boolean(Object.keys(userPanelConfigsLocalDatabaseContent).length);
    // Return the actual config object so the requiredAppDataState handler can
    // populate context.userPanelConfigs from IndexedDB without a cloud fetch.
    // Same pattern as userSettingsHelpers — previously only the flag was returned.
    return {
      hasUserPanelConfigsLocalDatabaseContent,
      userPanelConfigs: hasUserPanelConfigsLocalDatabaseContent ? userPanelConfigsLocalDatabaseContent : null,
    };
  } catch (error) {
    logger.error(error, 'Local database content NOT FOUND');
    return {
      hasUserPanelConfigsLocalDatabaseContent: false,
      userPanelConfigs: null,
    };
  }
};
